import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-transfer-to-minimal-dialog',
    templateUrl: './transfer-case-dialog.component.html',
    styleUrls: ['./transfer-case-dialog.component.scss']
})
export class TransferCaseDialogComponent implements OnInit {
    public message: string;
    public infoOnly: boolean;
    private transition: boolean;

    constructor(private dialogRef: MatDialogRef<TransferCaseDialogComponent>, @Inject(MAT_DIALOG_DATA) private data) {
        this.dialogRef.disableClose = true;
    }

    ngOnInit() {
        this.message = this.data.message;
        this.infoOnly = this.data.infoOnly;
        this.transition = this.data.transition || false;
    }

    cancel() {
        this.dialogRef.close();
    }

    proceed(transfer: boolean) {
        this.dialogRef.close(transfer);
    }

    processInfoOnly() {
        this.dialogRef.close(this.transition);
    }
}
